import { Injectable } from '@angular/core';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlfrescoApiService } from '@alfresco/adf-core';
import { LoanActionTypes } from '../store/actions/loan-actions';
import { CreateLoanDialogComponent } from '../dialogs/loans/create-loan/create-loan.dialog';
import { UdeuLoan } from '../model/classes/udeu-loan';
import { AppStore } from '@alfresco/aca-shared/store';
import { Store } from '@ngrx/store';
import { NodePaging } from '@alfresco/js-api';
import { SYS_NODE_UUID_PROP } from '../model/contants/deusto';
import { LoanRenewDialogComponent } from '../dialogs/loans/create-loan/renew/renew.dialog';

@Injectable({
  providedIn: 'root'
})
export class LoanService {
  constructor(public dialog: MatDialog, private alfrescoApiService: AlfrescoApiService, protected store: Store<AppStore>) { }

  openLoanDialogComponent(UUID: string, loanActionType: LoanActionTypes, openedByUrl?: boolean): MatDialogRef<CreateLoanDialogComponent> {
    return this.dialog.open(CreateLoanDialogComponent,
      {
        disableClose: true,
        autoFocus: true,
        width: '80%',
        maxHeight: '90%',
        data:  { UUID, loanActionType, openedByUrl: (openedByUrl ? openedByUrl : false)  }
      },
    );
  }

  openCreateLoanDialogComponent(): void {
    this.dialog.open(CreateLoanDialogComponent,
      {
        disableClose: true,
        autoFocus: true,
        width: '80%',
        maxHeight: '90%',
        data:  { loanActionType: LoanActionTypes.CreateLoan }
      },
    );
  }

  openLoanRenewDialogComponent(loanId: string, validate: boolean = false, reject: boolean = false): MatDialogRef<LoanRenewDialogComponent> {
    return this.dialog.open(LoanRenewDialogComponent,
      {
        disableClose: true,
        autoFocus: true,
        minWidth: '600px',
        data:  { loanId, validate, reject }
      },
    );
  }

  getLoan(UUID: string): Promise<UdeuLoan> {
    const path = `smtecno/ssm/deusto/loan/${UUID}`;
    const httpMethod = 'GET';
    const pathParams = {};  // No funciona
    const queryParams = {};
    const headerParams = {};
    const formParams = {};
    const bodyParam = {};
    const contentTypes = [];
    const accepts = [];
    const returnType = '';
    const url = 'alfresco/service';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  getLoanByUuid(loanUUID: string): Promise<NodePaging> {
    const path = 'search';
    const httpMethod = 'POST';
    const pathParams = {};
    const queryParams = {};
    const headerParams = {};
    const formParams = {};
    const bodyParam = {
      query: {
        language: "afts",
        query: `${SYS_NODE_UUID_PROP}:'${loanUUID}'`
      },
      include: [
          "properties"
      ]
    };
    const contentTypes = [];
    const accepts = [];
    const returnType = '';
    const url = 'alfresco/api/-default-/public/search/versions/1';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  createLoan(loan: UdeuLoan): Promise<any> {
    const path = 'smtecno/ssm/deusto/loan';
    const httpMethod = 'POST';
    const pathParams = {};
    const queryParams = {};
    const headerParams = {};
    const formParams = {};
    const bodyParam = loan;
    const contentTypes = ['application/json'];
    const accepts = [];
    const returnType = '';
    const url = 'alfresco/service';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  updateLoan(UUID: string, loan: UdeuLoan): Promise<any> {
    const path = `smtecno/ssm/deusto/loan/${UUID}`;
    const httpMethod = 'PUT';
    const pathParams = {};
    const queryParams = {};
    const headerParams = {};
    const formParams = {};
    const bodyParam = loan;
    const contentTypes = ['application/json'];
    const accepts = [];
    const returnType = '';
    const url = 'alfresco/service';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  asssignRecord(loanUUID: string, lentRecords: string[], revoke: boolean = false, loanName?: string, status?: string): Promise<string> {
    const path = `smtecno/ssm/deusto/loan/assign`;
    const httpMethod = 'PUT';
    const pathParams = {};
    const queryParams = { delete: revoke };
    const headerParams = {};
    const formParams = {};
    const bodyParam = { id: loanUUID, status: {status: status},name: loanName, lentRecords };
    const contentTypes = ['application/json'];
    const accepts = ['text/plain'];
    const returnType = '';
    const url = 'alfresco/service';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  loanRenew(loan: UdeuLoan): Promise<string> {
    const path = `smtecno/ssm/deusto/loan/renew`;
    const httpMethod = 'PUT';
    const pathParams = {};
    const queryParams = {};
    const headerParams = {};
    const formParams = {};
    const bodyParam = loan;
    const contentTypes = ['application/json'];
    const accepts = ['text/plain'];
    const returnType = '';
    const url = 'alfresco/service';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  
  getReceipt(loanId: string, recordId: string): Promise<Blob> {
    const path = `/smtecno/ssm/deusto/template/receipt`;
    const httpMethod = 'POST';
    const pathParams = {};
    const queryParams = {};
    const headerParams = {};
    const formParams = { loanId, recordId };
    const bodyParam = {};
    const contentTypes = ['multipart/form-data'];
    const accepts = ['text/plain'];
    const returnType = 'blob';
    const url = 'alfresco/service';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

}
